import { render } from "./NewTicket.vue?vue&type=template&id=269164cd&scoped=true"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"

import "./NewTicket.vue?vue&type=style&index=0&id=269164cd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269164cd"]])

export default __exports__